/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { VistaControllerLookupsQueryResponse, VistaControllerLookupsPathParams, VistaControllerLookups400, VistaControllerLookups401, VistaControllerLookups403, VistaControllerLookups404 } from "../../models/changeOrdersController/VistaControllerLookups";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { vistaControllerLookups } from "../../clients/change-ordersService/vistaControllerLookups";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const vistaControllerLookupsQueryKey = (id: VistaControllerLookupsPathParams["id"]) => [{
  url: '/api/v1/potential-change-orders/:id/vista/lookups',
  params: {
    id: id
  }
}] as const;
export type VistaControllerLookupsQueryKey = ReturnType<typeof vistaControllerLookupsQueryKey>;
export function vistaControllerLookupsQueryOptions(id: VistaControllerLookupsPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = vistaControllerLookupsQueryKey(id);
  return queryOptions<VistaControllerLookupsQueryResponse, ResponseErrorConfig<VistaControllerLookups400 | VistaControllerLookups401 | VistaControllerLookups403 | VistaControllerLookups404>, VistaControllerLookupsQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return vistaControllerLookups(id, config);
    }
  });
}

/**
 * {@link /api/v1/potential-change-orders/:id/vista/lookups}
 */
export function useVistaControllerLookups<TData = VistaControllerLookupsQueryResponse, TQueryData = VistaControllerLookupsQueryResponse, TQueryKey extends QueryKey = VistaControllerLookupsQueryKey>(id: VistaControllerLookupsPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<VistaControllerLookupsQueryResponse, ResponseErrorConfig<VistaControllerLookups400 | VistaControllerLookups401 | VistaControllerLookups403 | VistaControllerLookups404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? vistaControllerLookupsQueryKey(id);
  const query = useQuery({
    ...vistaControllerLookupsQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<VistaControllerLookups400 | VistaControllerLookups401 | VistaControllerLookups403 | VistaControllerLookups404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}